import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ProductProvider } from './context/productcontext';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <ProductProvider>
        <App />
    </ProductProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

